export class FeedbackInput {
    message: string = '';
    previousPageUrl: string = '';
    partSearchTerm: string = '';
    branchCode: string = '';
    customerNumber: string = '';
    attachedFiles: FileAttachment[] = null;
}

// Class for holding the attached file content
export class FileAttachment {
  name: string = '';
  base64File: string = '';
  size: string = '';
  mimeType: string = '';
}
